import * as React from 'react';
import { withStepper } from '../../dist/src/with-stepper';
const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: 32,
    paddingBottom: 32,
    background: 'whitesmoke',
};
const commonPageStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
};
const activePageStyle = Object.assign({}, commonPageStyle, { width: 250, height: 250 });
const inactivePageStyle = Object.assign({}, commonPageStyle, { width: 50, height: 50 });
export const CowerFlow = withStepper(({ pages, currentPage, setPageIndex }) => React.createElement("div", { style: containerStyle }, pages.map((page, i) => React.createElement("div", { key: i, onClick: () => setPageIndex(i), style: i === currentPage
        ? activePageStyle
        : inactivePageStyle }, page.render ? page.render() : React.createElement(page.component, null)))));



// WEBPACK FOOTER //
// ./docs/src/05-custom-components.tsx